"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SplitGDGuidesSection;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _image = require("@site/pattern-library-core/image");
var _section = _interopRequireDefault(require("@site/pattern-library-core/section"));
var _panel = _interopRequireDefault(require("./common/panel.js"));
var _attribution = _interopRequireDefault(require("./common/attribution.js"));
var _styles = require("./common/styles.js");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
const Container = /*#__PURE__*/(0, _react2.styled)("section")({
  name: "Container",
  class: "pl-c1292ic7",
  vars: {
    "c1292ic7-1": [({
      layout
    }) => layout === 'split' ? 'row' : 'row-reverse'],
    "c1292ic7-2": [({
      backgroundColor
    }) => backgroundColor ? backgroundColor : _intents.default.ux.box.backgroundColor]
  }
});
const ImageContainer = /*#__PURE__*/(0, _react2.styled)(_image.LazyBackgroundImage)({
  name: "ImageContainer",
  class: "pl-i1dwrxs3"
});

/**
 * Render Split GD Guides Section
 *
 * @param {Object} props React props
 * @param {boolean} props.invert Invert Color Props
 * @param {String} props.partial Theme partial
 * @param {string} props.layout Component's layout
 * @param {string} props.backgroundColor Background Color
 * @param {string} props.attribution Raw attribution text
 * @param {string} props.attributionPosition Attribution position
 * @param {string} props.sideImage Background Image URL
 * @param {string} props.verticalMargin Vertical Spacing value
 * @returns {React.ReactElement} Split GD Guides Section component
 * @public
 */
function SplitGDGuidesSection({
  _name,
  invert = false,
  partial,
  layout = 'split-reverse',
  backgroundColor,
  attribution,
  attributionPosition,
  sideImage,
  verticalMargin,
  ...otherProps
}) {
  const backgroundImages = {
    portrait: sideImage?.url,
    tablet: sideImage?.url,
    landscape: sideImage?.url
  };
  return /*#__PURE__*/_react.default.createElement(_section.default, {
    padding: "none",
    partial: partial || (invert ? 'dark1' : ''),
    verticalMargin: verticalMargin,
    dataCy: `gd-guides-section-${layout}`
  }, /*#__PURE__*/_react.default.createElement(Container, (0, _extends2.default)({
    layout: layout,
    backgroundColor: (0, _patternLibraryUtils.getBackgroundColor)(backgroundColor)
  }, (0, _patternLibraryUtils.create)(_name, false, true)), /*#__PURE__*/_react.default.createElement(ImageContainer, backgroundImages, attribution && /*#__PURE__*/_react.default.createElement(_attribution.default, {
    attribution: attribution,
    attributionPosition: attributionPosition
  })), /*#__PURE__*/_react.default.createElement(_panel.default, (0, _extends2.default)({
    partial: partial || (invert ? 'dark1' : '')
  }, otherProps))));
}
SplitGDGuidesSection.propTypes = {
  _name: _propTypes.default.string,
  layout: _propTypes.default.string,
  backgroundColor: _propTypes.default.oneOfType([_propTypes.default.shape({
    rgb: _propTypes.default.string
  }), _propTypes.default.shape({
    intent: _propTypes.default.string
  })]),
  sideImage: _propTypes.default.shape(_image.imgPropShape),
  ..._panel.default.propTypes,
  ..._attribution.default.propTypes,
  ..._patternLibraryUtils.marginProps
};